(function () {
  var AUTOMATION_ROOT_SELECTOR = '[data-rt-editor-automation="true"]';
  var TARGET_SELECTOR = [
    '.rich-text__image--positioned',
    '.rich-text__image--overlap-item',
    '.rich-text__image-slider--positioned',
    '.rich-text__text--positioned',
    '.rich-text__text--overlap-item',
    '.rich-text__button-position-area',
  ].join(', ');
  var CONTAINER_SELECTOR = [
    '.rich-text__image-position-area',
    '.rich-text__image-overlap-group',
    '.rich-text__image-slider-position-area',
    '.rich-text__text-position-area',
    '.rich-text__text-overlap-group',
    '.rich-text__button-position-area',
    '.rich-text__blocks',
  ].join(', ');
  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function clamp(value) {
    return Math.max(0, Math.min(100, value));
  }

  function round(value) {
    return Math.round(value * 10) / 10;
  }

  function stripUnit(value) {
    var numeric = parseFloat(String(value || '').replace('%', '').replace('px', ''));
    return Number.isFinite(numeric) ? numeric : 0;
  }

  function getTargetType(target) {
    if (target.classList.contains('rich-text__button-position-area')) return 'button';
    if (target.classList.contains('rich-text__image-slider--positioned')) return 'slider';
    if (target.classList.contains('rich-text__text--positioned') || target.classList.contains('rich-text__text--overlap-item')) return 'text';
    return 'image';
  }

  function getContainer(target) {
    var type = getTargetType(target);
    if (type === 'button') {
      return target.closest('.rich-text__blocks') || target.parentElement;
    }

    return target.closest(CONTAINER_SELECTOR);
  }

  function getCenter(target, container) {
    var targetRect = target.getBoundingClientRect();
    var containerRect = container.getBoundingClientRect();

    return {
      x: ((targetRect.left + targetRect.width / 2 - containerRect.left) / containerRect.width) * 100,
      y: ((targetRect.top + targetRect.height / 2 - containerRect.top) / containerRect.height) * 100,
    };
  }

  function getPointerPercent(event, container) {
    var rect = container.getBoundingClientRect();

    return {
      x: ((event.clientX - rect.left) / rect.width) * 100,
      y: ((event.clientY - rect.top) / rect.height) * 100,
    };
  }

  function getModeLabel() {
    return MOBILE_QUERY.matches ? '모바일' : 'PC';
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\#.;?+*~':!^$[\]()=>|/@]/g, '\\$&');
  }

  function getPositionVars(type, isMobile) {
    if (type === 'button') {
      return {
        left: isMobile ? '--rt-button-left-mobile' : '--rt-button-left',
        top: isMobile ? '--rt-button-top-mobile' : '--rt-button-top',
      };
    }

    if (type === 'text') {
      return {
        left: isMobile ? '--rt-text-left-mobile' : '--rt-text-left',
        top: isMobile ? '--rt-text-top-mobile' : '--rt-text-top',
      };
    }

    if (type === 'slider') {
      return {
        left: isMobile ? '--rt-slider-left-mobile' : '--rt-slider-left',
        top: isMobile ? '--rt-slider-top-mobile' : '--rt-slider-top',
      };
    }

    return {
      left: isMobile ? '--rt-image-left-mobile' : '--rt-image-left',
      top: isMobile ? '--rt-image-top-mobile' : '--rt-image-top',
    };
  }

  function setPosition(target, x, y) {
    var vars = getPositionVars(getTargetType(target), MOBILE_QUERY.matches);
    target.style.setProperty(vars.left, round(x) + '%');
    target.style.setProperty(vars.top, round(y) + '%');
  }

  function getPositionValues(target, container) {
    var center = getCenter(target, container);
    return {
      x: round(clamp(center.x)),
      y: round(clamp(center.y)),
    };
  }

  function getStyleValues(target) {
    var computed = window.getComputedStyle ? window.getComputedStyle(target) : null;
    var names = [
      '--rt-button-translate-x',
      '--rt-button-translate-y',
      '--rt-button-translate-x-mobile',
      '--rt-button-translate-y-mobile',
      '--rt-button-area-width',
      '--rt-button-area-width-mobile',
      '--rt-button-area-min-height',
      '--rt-button-area-min-height-mobile',
    ];
    var values = {};

    names.forEach(function (name) {
      values[name] = target.style.getPropertyValue(name) || (computed ? computed.getPropertyValue(name) : '');
    });

    return values;
  }

  function buildCopyText(type, values, isMobile, styleValues) {
    var suffix = isMobile ? '_mobile' : '';
    var lines = ['position_left' + suffix + ': ' + values.x, 'position_top' + suffix + ': ' + values.y];

    if (type === 'button') {
      lines.push('position_translate_x' + suffix + ': ' + stripUnit(styleValues['--rt-button-translate-x' + (isMobile ? '-mobile' : '')]));
      lines.push('position_translate_y' + suffix + ': ' + stripUnit(styleValues['--rt-button-translate-y' + (isMobile ? '-mobile' : '')]));
      lines.push('position_area_width' + suffix + ': ' + stripUnit(styleValues['--rt-button-area-width' + (isMobile ? '-mobile' : '')]));
      lines.push('position_area_height' + suffix + ': ' + stripUnit(styleValues['--rt-button-area-min-height' + (isMobile ? '-mobile' : '')]));
    }

    return lines.join('\n');
  }

  function getWarnings(options) {
    var warnings = [];
    var nearEdge = options.x <= 5 || options.x >= 95;

    if (options.type === 'button') {
      if (!options.label) warnings.push('button_label 비어 있음');
      if (options.scrollTarget && !options.scrollFound) warnings.push('scroll target 미검출');
      if (options.isMobile && (options.areaWidth > 100 || options.areaHeight > 600)) warnings.push('모바일 클릭 영역 100% 초과');
    }

    if (options.overlayGroup && !options.firstInGroup && options.hasGroupHeight) {
      warnings.push('첫 블록 외 overlay height 설정됨');
    }

    if (!options.constrainPosition && nearEdge && options.width >= 80) {
      warnings.push('좌표 잘림 방지 꺼짐');
    }

    return warnings;
  }

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).catch(function () {});
      return;
    }

    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  }

  function renderWarnings(panel, warnings) {
    var list = panel.querySelector('[data-rt-position-warnings]');
    if (!list) return;

    list.innerHTML = '';
    warnings.forEach(function (warning) {
      var item = document.createElement('span');
      item.textContent = warning;
      list.appendChild(item);
    });
    list.hidden = warnings.length === 0;
  }

  function resolveScrollTarget(target) {
    var rawTarget = target.dataset.rtScrollTarget || '';
    var id = rawTarget.replace(/^#/, '').replace(/^shopify-section-/, '');
    if (!id) return false;
    var escaped = cssEscape(id);

    return Boolean(
      document.getElementById(rawTarget) ||
        document.getElementById(id) ||
        document.getElementById('shopify-section-' + id) ||
        document.querySelector(
          '[data-section-id="' +
            escaped +
            '"], [data-rt-section-id="' +
            escaped +
            '"], [data-rt-section-anchor="' +
            escaped +
            '"], [id$="' +
            escaped +
            '"]'
        )
    );
  }

  function getWarningOptions(target, values) {
    var type = getTargetType(target);
    var isMobile = MOBILE_QUERY.matches;
    var styleValues = getStyleValues(target);

    return {
      type: type,
      isMobile: isMobile,
      label: target.dataset.rtButtonLabel || '',
      scrollTarget: target.dataset.rtScrollTarget || '',
      scrollFound: resolveScrollTarget(target),
      areaWidth: stripUnit(styleValues['--rt-button-area-width' + (isMobile ? '-mobile' : '')]),
      areaHeight: stripUnit(styleValues['--rt-button-area-min-height' + (isMobile ? '-mobile' : '')]),
      overlayGroup: target.dataset.rtOverlayGroup || '',
      firstInGroup: target.dataset.rtFirstInGroup !== 'false',
      hasGroupHeight: target.dataset.rtHasGroupHeight === 'true',
      constrainPosition: target.dataset.rtConstrainPosition === 'true',
      x: values.x,
      width: Number(target.dataset.rtWidthMobile && isMobile ? target.dataset.rtWidthMobile : target.dataset.rtWidth) || 100,
    };
  }

  function updatePanel(target) {
    var container = getContainer(target);
    var panel = target.querySelector('[data-rt-position-panel]');
    if (!container || !panel) return;

    var values = getPositionValues(target, container);
    var type = getTargetType(target);
    var copyValue = buildCopyText(type, values, MOBILE_QUERY.matches, getStyleValues(target));

    panel.querySelector('[data-rt-position-mode]').textContent = getModeLabel();
    panel.querySelector('[data-rt-position-type]').textContent = type;
    panel.querySelector('[data-rt-position-x]').textContent = values.x;
    panel.querySelector('[data-rt-position-y]').textContent = values.y;
    panel.querySelector('[data-rt-copy-all]').dataset.copyValue = copyValue;
    renderWarnings(panel, getWarnings(getWarningOptions(target, values)));
  }

  function createHelper(target) {
    if (target.dataset.rtPositionHelperReady === 'true') return;
    if (!target.closest(AUTOMATION_ROOT_SELECTOR)) return;
    if (!getContainer(target)) return;

    target.dataset.rtPositionHelperReady = 'true';
    target.classList.add('rich-text__position-helper-ready');

    var handle = document.createElement('button');
    handle.type = 'button';
    handle.className = 'rt-position-helper__handle';
    handle.setAttribute('aria-label', '위치 드래그');
    handle.textContent = 'DND';

    var panel = document.createElement('div');
    panel.className = 'rt-position-helper__panel';
    panel.dataset.rtPositionPanel = 'true';
    panel.innerHTML =
      '<strong><span data-rt-position-mode></span> <span data-rt-position-type></span></strong>' +
      '<span>X <b data-rt-position-x></b>%</span>' +
      '<span>Y <b data-rt-position-y></b>%</span>' +
      '<button type="button" data-rt-copy-all>Copy settings</button>' +
      '<div class="rt-position-helper__warnings" data-rt-position-warnings hidden></div>';

    target.appendChild(handle);
    target.appendChild(panel);

    handle.addEventListener('pointerdown', function (event) {
      var container = getContainer(target);
      if (!container) return;

      event.preventDefault();
      event.stopPropagation();

      var startPointer = getPointerPercent(event, container);
      var startCenter = getPositionValues(target, container);
      var moved = false;

      target.classList.add('is-position-dragging');
      handle.setPointerCapture(event.pointerId);

      function onMove(moveEvent) {
        var pointer = getPointerPercent(moveEvent, container);
        var nextX = clamp(startCenter.x + pointer.x - startPointer.x);
        var nextY = clamp(startCenter.y + pointer.y - startPointer.y);

        moved = true;
        setPosition(target, nextX, nextY);
        updatePanel(target);
      }

      function onEnd(endEvent) {
        target.classList.remove('is-position-dragging');
        handle.releasePointerCapture(endEvent.pointerId);
        handle.removeEventListener('pointermove', onMove);
        handle.removeEventListener('pointerup', onEnd);
        handle.removeEventListener('pointercancel', onEnd);

        if (moved) {
          endEvent.preventDefault();
          endEvent.stopPropagation();
        }
      }

      handle.addEventListener('pointermove', onMove);
      handle.addEventListener('pointerup', onEnd);
      handle.addEventListener('pointercancel', onEnd);
    });

    panel.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-rt-copy-all]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      copyText(button.dataset.copyValue || '');
      button.textContent = 'Copied';
      setTimeout(function () {
        button.textContent = 'Copy settings';
      }, 900);
    });

    updatePanel(target);
  }

  function init(scope) {
    if (!window.Shopify || !window.Shopify.designMode) return;
    (scope || document).querySelectorAll(TARGET_SELECTOR).forEach(createHelper);
  }

  window.RichTextPositionHelper = {
    buildCopyText: buildCopyText,
    getWarnings: getWarnings,
  };

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll(TARGET_SELECTOR).forEach(updatePanel);
  });
})();
